var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    clipPath: "url(#clip0_176_25221)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 113",
    cx: 8,
    cy: 8.22917,
    rx: 8,
    ry: 7.90105,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 84",
    d: "M11 5.2666L4.99988 11.1925",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 85",
    d: "M11 11.1924L4.99988 5.26647",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_25221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.8021,
    fill: "white",
    transform: "translate(0 0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTransparent);
export default __webpack_public_path__ + "static/media/close-transparent.c61ac9d953770c2c7836d6da8051ef49.svg";
export { ForwardRef as ReactComponent };